module.exports = __webpack_public_path__ + "static/media/Pia-oval.eb9ae73e.jpg";